import { HTTPInstanceWithPrefix } from '@/lib/http/http-instance-with-prefix'
import { ImageType } from '@/shared/api/BaseAPI.model'
import {
  dietsType,
  dishesResponseModel,
  dishCreatedModel,
  dishPayloadModel,
  dishPutPayloadModel,
  spiceLevelsModel
} from './DishesAPI.model'

class DishesAPI {
  static postDish = (payload: dishPayloadModel): Promise<dishCreatedModel> =>
    HTTPInstanceWithPrefix.post('/dishes', payload).then(
      response => response.data
    )

  static getDishes = (): Promise<dishesResponseModel> =>
    HTTPInstanceWithPrefix.get('/dishes').then(response => response.data)

  static deleteDishes = (dishIds: string[]): Promise<void> =>
    HTTPInstanceWithPrefix.delete('/dishes', {
      data: { ids: dishIds }
    }).then(response => response.data)

  static putDish = (
    payload: dishPayloadModel,
    dishId: string
  ): Promise<dishPutPayloadModel> =>
    HTTPInstanceWithPrefix.put(`/dishes/${dishId}`, payload).then(
      response => response.data
    )

  static getDish = (dishId: string): Promise<dishPayloadModel> =>
    HTTPInstanceWithPrefix.get(`/dishes/${dishId}`).then(
      response => response.data
    )

  // dishes images

  static postDishImage = (formData: FormData, dishId: string): Promise<void> =>
    HTTPInstanceWithPrefix.post(`/dishes/${dishId}/images`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(response => response.data)

  static getDishImage = (dishId: string): Promise<ImageType> =>
    HTTPInstanceWithPrefix.get(`/dishes/${dishId}/images`).then(
      response => response.data
    )

  static deleteDishImage = (dishId: string): Promise<void> =>
    HTTPInstanceWithPrefix.delete(`/dishes/${dishId}/images`).then(
      response => response.data
    )

  static getAllSpiceLevels = (): Promise<spiceLevelsModel[]> =>
    HTTPInstanceWithPrefix.get('/all-spice-levels').then(
      response => response.data
    )

  static getAllDiets = (): Promise<dietsType[]> =>
    HTTPInstanceWithPrefix.get('/all-diets').then(response => response.data)
}

export default DishesAPI
